/**
 * 是否是企微域名
 */
export function isCorpWeChat() {
    return window.location.hostname === 'doc.weixin.qq.com';
}
